'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$asyncHttp", function ($q, security, $timeout, $http, $httpErrorHandler, $dateConverter, $dialogBox, $notifications, urlUtils) {
  function waitForCompletion(taskId) {
    function poll() {
      return $http.get('/rest/user-tasks/status/' + taskId).then(function (response) {
        var status = response.data;
        if (status === 'COMPLETED' || status === 'ERROR') {
          return status;
        }
        return $timeout(2000).then(poll);
      });
    }
    return poll();
  }
  function asyncCall(method, url, data) {
    var authenticatedUrl = urlUtils.addParams(url, security.getTokens());
    return $http.post('/rest/async-call/execute', {
      method: method,
      url: authenticatedUrl,
      data: data
    }).then(function (response) {
      var taskId = response.data.response;
      return waitForCompletion(taskId).then(function (status) {
        if (status !== 'COMPLETED') {
          return $http.get('/rest/user-tasks/errorMessage/' + taskId).then(function (response) {
            var error = new Error(response.data || "Erreur sur l'appel sync");
            error.taskId = taskId;
            error.status = status;
            throw error;
          });
        }
        var downloadUrl = "/rest/user-tasks/downloadUserTaskGeneratedCallResult/" + taskId;
        var authenticatedDownloadUrl = urlUtils.addParams(downloadUrl, security.getTokens());
        return $http.get(authenticatedDownloadUrl);
      });
    });
  }
  return {
    get: function get(url, data) {
      return asyncCall('GET', url, data.params);
    },
    post: function post(url, data) {
      return asyncCall('POST', url, data);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/http/$asyncHttp.js
// module id = 2710
// module chunks = 13